module.exports = __webpack_public_path__ + "static/pinkunicorn3-e6ca5be0e74e9e89d6a835dc1d48f6cd.jpeg";